/* styles */
import useStyles from './useStyles'
import { Checkbox, IconButton, Tooltip } from '@mui/material'
import GppGoodOutlinedIcon from '@mui/icons-material/GppGoodOutlined'
import GppBadOutlinedIcon from '@mui/icons-material/GppBadOutlined'
import ModalMenuItem from '../../Modals/ModalMenu/ModalMenu'

function TableItem ({ item, suscriber, types, setLoading }) {
  const classes = useStyles()
  const getTraducTypeOrg = (codeType) => {
    const type = types.filter((type) => type.organizationTypeId === codeType)
    if (type.length > 0) {
      const [typeFilter] = type
      return typeFilter.organizationTypeName
    } else {
      return null
    }
  }
  return (
    <>
      <tr className={classes.row}>
        <td className={classes.itemCheck}>
          <Checkbox />
        </td>
        <td className={classes.itemIcon}>
          {item.isActive
            ? (
            <Tooltip title="Activo">
              <IconButton>
                <GppGoodOutlinedIcon className={classes.hoverButton} />
              </IconButton>
            </Tooltip>
              )
            : (
            <Tooltip title="No activo">
              <IconButton>
                <GppBadOutlinedIcon className={classes.hoverButtonDelete} />
              </IconButton>
            </Tooltip>
              )}
        </td>
        <td className={classes.itemName}>{item.organizationName || '- -'}</td>
        <td className={classes.itemLegalName}>
          {item.organizationLegalName || '- -'}
        </td>
        <td className={classes.itemCuit}>{item.organizationCuit || '- -'}</td>
        <td className={classes.itemType}>
          {getTraducTypeOrg(item.organizationTypeId) || '- -'}
        </td>

        <td className={classes.itemKebab}>
          <ModalMenuItem
            item={item}
            suscriber={suscriber}
            setLoading={setLoading}
          />
        </td>
      </tr>
    </>
  )
}

export default TableItem
